module.exports = __webpack_public_path__ + "static/a-tipo-cirugia-tratamento-6c2cf97b11a458214a66f711e892c063.jpg";